import cn from 'classnames'
import React from 'react'
import { observer } from 'mobx-react'
import { Tooltip } from 'react-tooltip'

import {
   FIELD_LABEL_DATA_ATTRIBUTE,
   FIELD_LABEL_TOOLTIP_ID
} from '@flowwai-frontend/shared-web/common/ui'

import * as Styles from './styles'

interface Props {
   containerClassName?: string
}

const FieldLabelTooltip = (props: Props): React.ReactElement => {
   const { containerClassName } = props

   return (
      <Tooltip
         id={FIELD_LABEL_TOOLTIP_ID}
         place='top'
         opacity={1}
         className={cn(Styles.tooltipStyles, containerClassName)}
         render={({ activeAnchor }) => {
            const label = activeAnchor?.getAttribute(FIELD_LABEL_DATA_ATTRIBUTE)

            if (!label) return null

            return <p className={Styles.tooltipTitleStyles}>{label}</p>
         }}
      />
   )
}

export default observer(FieldLabelTooltip)
